import type { enAdaptive } from "./en.adaptive";

/** Russian for the phone and the narrow and wide screens (see `en.adaptive.ts`). Words from the boards M*, Camp1280, Camp1920. */
export const ruAdaptive: Record<keyof typeof enAdaptive, string> = {
  "adapt.tab.report": "Отчёт",
  "adapt.tab.more": "Ещё",
  "adapt.back": "Назад: {place}",
  "adapt.approve": "апрув {pct}",
  "adapt.today.caption": "Профит сегодня, до {at} · {tz}",
  "adapt.today.vsYesterday": "к вчера",
  "adapt.sort": "Сортировать",
  "adapt.sortBy.profit": "по профиту",
  "adapt.sortBy.roi": "по ROI",
  "adapt.sortBy.clicks": "по кликам",
  "adapt.sortBy.leads": "по лидам",
  "adapt.sortBy.cost": "по расходу",
  "adapt.sortBy.name": "по названию",
  "adapt.path.lpCtr": "{pct} LP CTR",
  "adapt.path.cr": "CR {cr}",
  "adapt.report.total": "Итого",
  "adapt.report.starts": "Быстрые отчёты",
  "adapt.report.start.country": "По странам",
  "adapt.report.start.campaign": "По кампаниям",
  "adapt.report.start.hour": "По часам",
  "adapt.report.sub": "{clicks} кл · {leads} {word}",
};
